import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

import { NotificationInterface } from '@e3labs/isa-data-dictionary';

import * as S from './styles';

interface ModalNotificationProps {
  notification: NotificationInterface<any>;
  isOpen: boolean;
  onClose: () => void;
}

const ModalNotification = ({ isOpen, onClose, notification }: ModalNotificationProps) => (
  <Dialog fullWidth open={isOpen} onClose={onClose}>
    <S.DialogTitle>{notification?.title}</S.DialogTitle>
    <S.DialogContent dividers>
      <DialogContentText>{notification?.shortMessage}</DialogContentText>
      {notification?.htmlBody !== '<p><br></p>' && (
        <DialogContentText
          dangerouslySetInnerHTML={{
            __html: notification?.htmlBody!
          }}
        />
      )}
    </S.DialogContent>
    <DialogActions>
      <Button onClick={onClose}>OK</Button>
    </DialogActions>
  </Dialog>
);

export default ModalNotification;
